import type { ChatReaction } from '../../store/types'

// One reaction per person. The wire/DB model still allows a person to hold more
// than one emoji (reactor_ids is a list per emoji) — this only constrains the
// client so a viewer contributes at most one. Picking a new emoji replaces the
// old one; picking your current one clears it.

// The emoji the viewer currently reacts with on a message, if any.
export function myReactionEmoji(
  reactions: ChatReaction[] | undefined,
  myUserID: string,
): string | undefined {
  return (reactions ?? []).find((r) => r.reactor_ids.includes(myUserID))?.emoji
}

// Return the reactions array with the viewer set to exactly `emoji` (or removed
// entirely when `emoji` is null): drop the viewer from every emoji they were on,
// prune any that hit zero, then add them to the target. Pure — the optimistic
// update in ChatRoomScreen applies it, and the server calls mirror it.
export function setMyReaction(
  reactions: ChatReaction[] | undefined,
  myUserID: string,
  emoji: string | null,
): ChatReaction[] {
  let out = (reactions ?? [])
    .map((r) =>
      r.reactor_ids.includes(myUserID)
        ? { ...r, count: r.count - 1, reactor_ids: r.reactor_ids.filter((id) => id !== myUserID) }
        : r,
    )
    .filter((r) => r.count > 0)
  if (emoji) {
    const idx = out.findIndex((r) => r.emoji === emoji)
    if (idx === -1) {
      out = [...out, { emoji, count: 1, reactor_ids: [myUserID] }]
    } else {
      out = out.map((r, i) =>
        i === idx ? { ...r, count: r.count + 1, reactor_ids: [...r.reactor_ids, myUserID] } : r,
      )
    }
  }
  return out
}
